/**
 * ¿La cuenta de WhatsApp de este canal está castigada por WhatsApp?
 *
 * Espejo de `channel-restriction.ts` del conversation-service. Existía la misma lógica copiada en
 * cuatro lugares del admin (grilla de Canales, ficha del canal, Nuevo mensaje y el chat), y las
 * cuatro pedían lo mismo: **una fecha de vencimiento futura**.
 *
 * Ese era el bug: WhatsApp no siempre manda `time_enforcement_ends`, y ahora además hay
 * restricciones que deducimos de una racha de timeouts y que por definición no traen fecha. Con la
 * regla vieja no se veían en ningún lado y el panel dejaba escribir contra un número restringido.
 *
 * Hay restricción si hay `restrictionType`, tenga fecha o no. La fecha, cuando está, sirve para que
 * venza sola sin que nadie limpie nada.
 */
export interface EstadoRestriccion {
  restrictedUntil?: string | null;
  restrictionType?: string | null;
}

export function estaRestringido(canal?: EstadoRestriccion | null): boolean {
  if (!canal) return false;
  if (canal.restrictedUntil) return new Date(canal.restrictedUntil).getTime() > Date.now();
  return Boolean(canal.restrictionType);
}

/**
 * Texto del vencimiento para mostrar al operador.
 *
 * Sin fecha no se inventa una: decir "hasta el Invalid Date" es peor que no decir nada, y "hasta
 * que WhatsApp la levante" es literalmente lo que pasa.
 */
export function textoVencimiento(restrictedUntil?: string | null): string {
  if (!restrictedUntil) return "hasta que WhatsApp la levante";
  const d = new Date(restrictedUntil);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `hasta el ${dd}/${mm}/${d.getFullYear()} a las ${hh}:${mi}`;
}
